// extracted by mini-css-extract-plugin
module.exports = {"checkBoxRegister":"AgreementCheckBoxField-module--checkBoxRegister--321EN"};